<template>
  <!-- Одобренный лимит: показывается только при положительном лимите
       (условие и сумма — с сервера, /index → dicAppliedLimits) -->
  <!-- оформление как в прежнем ЛК (синий заголовок и текст) на белой панели;
       справа через разделитель — «Ваш лимит», сумма и кнопка (по ТЗ) -->
  <section class="st-panel st-limit" aria-labelledby="lim-h">
    <div>
      <div id="lim-h" class="h4 mb-2 mt-0 text-primary">
        Статус «Надёжный клиент»
      </div>
      <p class="st-limit__text">
        В благодарность за наше плодотворное сотрудничество Вам присвоен статус
        «Надёжный клиент». Вы можете оформить лизинг автотранспорта или
        спецтехники в рамках заранее одобренного лимита по финансированию без
        проверок и документов.
      </p>
    </div>
    <div class="st-limit__side">
      <div class="st-limit__label">Ваш лимит</div>
      <div class="st-limit__sum">{{ money(amount) }}</div>
      <button
        class="st-btn st-btn--base st-btn--lg st-btn--block"
        type="button"
        @click="open = true"
      >
        Воспользоваться лимитом
      </button>
    </div>

    <!-- «Новая заявка с лимитом»: два пути — каталог или своя техника (общая
         форма заявки с включённым лимитом; сумма лимита — у переключателя).
         Шапка и тело — как у окна заявки (app-modal__*) -->
    <ui-modal v-if="open" medium :close="close">
      <div class="modal-header app-modal__head">
        <h5 class="modal-title">Новая заявка с лимитом</h5>
        <button class="btn-close" type="button" @click="close"></button>
      </div>
      <div class="modal-body app-modal__body st">
        <div class="lim-q">Как удобнее выбрать технику?</div>
        <div class="lim-options">
          <button class="lim-option" type="button" @click="catalog">
            <span class="lim-option__icon" aria-hidden="true">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7" rx="1.5" /><rect x="14" y="3" width="7" height="7" rx="1.5" /><rect x="3" y="14" width="7" height="7" rx="1.5" /><rect x="14" y="14" width="7" height="7" rx="1.5" /></svg>
            </span>
            <span class="lim-option__text">
              <b>Выбрать в каталоге</b>
              <small>Новая техника и с пробегом</small>
            </span>
            <svg class="lim-option__chev" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6" /></svg>
          </button>
          <button class="lim-option" type="button" @click="own">
            <span class="lim-option__icon" aria-hidden="true">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9" /><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z" /></svg>
            </span>
            <span class="lim-option__text">
              <b>Указать свою технику</b>
              <small>Знаете модель или есть КП</small>
            </span>
            <svg class="lim-option__chev" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6" /></svg>
          </button>
        </div>

        <p class="lim-note">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9" /><path d="M12 11v5M12 8h.01" /></svg>
          Выбор ничего не резервирует и не списывает — условия проверит менеджер
        </p>
      </div>
    </ui-modal>

    <!-- своя техника / КП: общая форма заявки, лимит выбран сразу -->
    <ApplicationModal
      v-if="ownOpen"
      kind="own"
      :limit="Number(amount)"
      use-limit
      @close="ownOpen = false"
    />
  </section>
</template>

<script>
import ApplicationModal from "@/component/application/ApplicationModal.vue";
import { rub, money } from "../helpers";
// стили блока и окна лимита (st-*, lim-*) — явно, а не только через Main.vue
import "../home.css";

export default {
  name: "LimitBlock",
  components: { ApplicationModal },
  props: {
    amount: { type: [Number, String], required: true },
  },
  data() {
    return {
      open: false,
      // окно заявки на свою технику
      ownOpen: false,
    };
  },
  methods: {
    rub,
    money,
    close() {
      this.open = false;
    },
    // каталог; ?limit=1 — заявки на свою технику там открываются с включённым
    // лимитом
    catalog() {
      this.open = false;
      this.$router.push({ path: "/catalog", query: { limit: "1" } });
    },
    // своя техника — общая форма заявки менеджеру с включённым лимитом
    own() {
      this.open = false;
      this.ownOpen = true;
    },
  },
};
</script>
